import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '../assets/audioGuide/r_picture.png';
const _hoisted_1 = {
  class: "childExhibitonItem"
};
const _hoisted_2 = {
  class: "audio-box"
};
const _hoisted_3 = {
  class: "audio"
};
const _hoisted_4 = {
  class: "img-cover"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "audio-desc"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "audio-menu"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.childExhibitions, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: "img-box",
      onClick: $event => $options.toAudioList(item)
    }, [_createElementVNode("img", {
      class: "audio-img",
      src: item.images
    }, null, 8, _hoisted_6)], 8, _hoisted_5)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
      onClick: $event => $options.toAudioList(item),
      class: "audio-name"
    }, [_createElementVNode("div", null, _toDisplayString($props.language ? item.en_name : item.exhibName), 1)], 8, _hoisted_8), _withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
      class: "audio-location",
      onClick: $event => $options.toAudioList(item)
    }, [_cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "location",
      src: _imports_0
    }, null, -1)), _createElementVNode("span", _hoisted_11, _toDisplayString($props.language ? item.en_brfDesc : item.desc), 1)], 8, _hoisted_10)], 512), [[_vShow, item.desc || item.en_brfDesc]])])]);
  }), 256))])]);
}